module.exports = __webpack_public_path__ + "static/media/izy.13699b3b.PNG";